export const SESSION_STORAGE_VERIFICATION = 'verification';
export const SESSION_STORAGE_MODE = 'MODE';
export const SESSION_STORAGE_SURVEY_SHOWN = 'wasSurveyShown';
export const SESSION_STORAGE_SURVEY_NEXT_SIGN_IN_SHOWN =
  'wasSurveyNextSignInShown';
export const SESSION_STORAGE_PRIVACY_POLICY_ACCEPTED = 'privacyPolicy';
export const SESSION_STORAGE_TOTAL_TICKETS = 'totalTickets';
export const OLD_LOCAL_STORAGE_VERIFICATION = 'session.CURRENT_V3';
export const LOCAL_STORAGE_WAITING_LIST_ID = 'wlID';
export const LOCAL_STORAGE_USER_LOCALE = 'app.user-locale';
export const LOCAL_STORAGE_SLUG = 'current_fangroup_slug';
export const SESSION_STORAGE_EMAIL_REMINDER = 'email_reminder';
export const SESSION_STORAGE_TARGET_APP = 'target_app';
export const SEATERS_COOKIES_ACCEPTED = 'SEATERS_COOKIES_ACCEPTED';
export const SESSION_STORAGE_JOB_ID = 'jobId';
export const SESSION_STORAGE_OAUTH_ORIGIN_URL = 'oauthOriginUrl';
export const SESSION_STORAGE_POST_LOGIN_REDIRECT_LOCATION =
  'post_login_redirect_location';
export const SESSION_STORAGE_DELETION_CANCELLED = 'deletionCancelled';
/**
 * Loop breaker for the landing page's OAuth auto-redirect (see
 * `oauth-constants.ts`). Deliberately in **localStorage**: the failing flow is a
 * chain of full-page OAuth round-trips, and the contexts where it loops hardest
 * (iOS tab discard/restore, app-to-browser hand-off, the 401 interceptor wiping
 * the session) are exactly the ones that lose sessionStorage — which made a
 * per-tab marker a no-op precisely when the guard was needed.
 */
export const LOCAL_STORAGE_OAUTH_AUTO_REDIRECT_AT = 'oauthAutoRedirectAt';
/**
 * Authorization codes already exchanged at `verify-oauth`, so a reload cannot
 * replay a single-use code (SEATERS-BACKEND-JAVA-J0). localStorage, not
 * sessionStorage: the reported replays come from iOS tab discard/restore, which
 * is exactly what a per-tab marker loses — as for the auto-redirect marker above.
 */
export const LOCAL_STORAGE_REDEEMED_OAUTH_CODES = 'oauthRedeemedCodes';
/**
 * When the fan last declined the post-join "get notified by phone" prompt.
 * localStorage, not sessionStorage: a per-tab marker would re-ask on the next
 * join in a new tab. Per-device is an accepted limit — `fan_capture_response`
 * validates item keys against visible prompts, so it cannot hold this one.
 */
export const LOCAL_STORAGE_PHONE_PROMPT_SNOOZED_AT = 'phonePromptSnoozedAt';
/**
 * Set when the fan closes that prompt without deciding (the X, or a click away).
 * sessionStorage deliberately: closing a dialog is a weaker signal than the
 * explicit "Not now", so it must not buy the 30-day snooze above.
 */
export const SESSION_STORAGE_PHONE_PROMPT_DISMISSED = 'phonePromptDismissed';
/**
 * When the fan dismissed the phone-verification banner. Its own key, so closing
 * the banner does not also silence the post-join dialog. Timestamped rather than
 * a flag: a tab left open for days should still get asked again.
 */
export const SESSION_STORAGE_PHONE_BANNER_DISMISSED_AT =
  'phoneBannerDismissedAt';
export const LOCAL_STORAGE_STRIPE_DEEP_LINK = 'stripeDeepLink';
export const SESSION_STORAGE_ALLOWED_GROUPS = 'allowedGroups';
/**
 * The Smart Invites share links the fan opened but has not joined yet, as
 * `{ [slug]: token[] }`. The token lives only in the join URL, so without this
 * a fan who wanders off before clicking "Join" loses the invite for good.
 */
export const SESSION_STORAGE_SMART_INVITE_SHARE_LINK = 'smartInviteShareLink';
export const SESSION_STORAGE_INTERFACE_CONTEXT = 'interfaceContext';
/**
 * Durable copy of `SESSION_STORAGE_INTERFACE_CONTEXT`. sessionStorage is
 * per-tab and is wiped wholesale by the 401 interceptor, so the last interface
 * the user was on also lives in localStorage for new tabs and fresh logins to
 * inherit.
 */
export const LOCAL_STORAGE_INTERFACE_CONTEXT = 'last_interface_context';

export const LOCATION_STATES = {
  REDIRECT_PATH: 'redirectPath',
} as const;
